import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'LocalGluons';
import { t } from 'Locale';
import { useStore } from 'Store';
import type { NativeConsentDefinition } from 'types';
import { Device } from 'DeviceUtils';
import { View, Text, Pressable, ScrollView, BackHandler } from 'react-native';
import InfoPage from '../../InfoPage/InfoPage';

import NativeConsentItem from '../NativeConsentItem/NativeConsentItem';
import Checkbox from '../NativeConsentCheckBox';
import style from './NativeConsentsDetailed.jss';


interface ConsentsDetailedProps {
    navigation: any;
    route: any;// wip
}

const ConsentsDetailed = (params: ConsentsDetailedProps): JSX.Element => {
    const { navigation, route } = params;
    const [consents, setConsents] = useState<Array<NativeConsentDefinition>>([]);
    const allSelected = consents.every((consent) => consent.approval);
    const scrollViewRef = useRef<ScrollView>(null);
    const setShowConsentsAgain = route?.params?.setShowConsentsAgain || false;
    const [postConsents, setPostConsents] = useState<boolean | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const { appManager } = useStore();
    const {
        backstageConnector: { auth }
    } = appManager.getApi();

    useEffect(() => {
        const fetchNativeConsents = async () => {
            try {
                const response = await auth.getNativeConsents();
                const initConsents = response.consents;
                setConsents(initConsents);
            } catch (error) {
                console.log(error);
            }
        };
        fetchNativeConsents();
    }, [auth]);

    const handleAcceptSelected = async () => {
        const selectedConsents = consents.map((consent) => ({
            name: consent.name,
            value: consent.approval
        }));
        try {
            const post = await auth.postNativeConsents({ consents: selectedConsents });
            const loggedUserData = await appManager.getLoggedUserObjectDataFromStorage();
            appManager.refreshToken(loggedUserData);
            setPostConsents(post.success);
            setErrorMessage(post.errorMessage);
            if (setShowConsentsAgain) {
                navigation.navigate('home');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleSelectAll = () => {
        if (allSelected === false) {
            setConsents(consents.map((consent) => ({ ...consent, approval: true })));
        }
        if (scrollViewRef.current) {
            scrollViewRef.current.scrollToEnd({ animated: true });
        }
        // if (allSelected === true) {
        //     setConsents(consents.map((consent) => ({ ...consent, approval: false })));
        // }
    };

    const handleSelect = (index: number) => {
        setConsents((prevConsents) => {
            const updatedConsents = [...prevConsents];
            updatedConsents[index] = {
                ...updatedConsents[index],
                approval: !consents[index].approval
            };
            return updatedConsents;
        });
    };

    useEffect(() => {
        const handleBackPress = () => {
            if (route.params?.setShowConsentsAgain) {
                setShowConsentsAgain(true);
                navigation.navigate('home');
                return true;
            }
            if (route.params?.setShowConsentsAgain === undefined) {
                navigation.pop();
                return true;
            }
            return true;
        };

        const listener = BackHandler.addEventListener('hardwareBackPress', handleBackPress);

        return () => {
            listener?.remove();
        };
    }, [setShowConsentsAgain, navigation]);

    const closeSuccesAndReturn = () => {
        if (Device.isPhone) {
            navigation.pop();
        } else {
            setPostConsents(false);
        }
    };

    if (postConsents) {
        return (
            <View style={style.postedCOnsentsFromSettingContainer}>
                <View style={{ ...style.infoPageContainer }}>
                    <InfoPage
                        heading={
                            errorMessage == null
                                ? t('CONSENTS.SETTINGS_SAVE_OK_TITLE')
                                : t('CONSENTS.SETTINGS_SAVE_ERROR_TITLE')
                        }
                        message={
                            errorMessage == null
                                ? t('CONSENTS.SETTINGS_SAVE_OK_DESCRIPTION')
                                : errorMessage
                        }
                        hideIcon
                    // onClose={closeSuccesAndReturn}
                    />
                </View>
                <View style={[style.bottomButtonPadding, style.confitmClosebutton]}>
                    <Button title={t('COMMON.CLOSE')} onPress={closeSuccesAndReturn} />
                </View>
            </View>
        );
    }

    return (
        <View style={style.container}>
            {Device.isTabletOrWeb && (
                <ScrollView ref={scrollViewRef}>
                    <View style={style.webContainer}>
                        <View
                            style={
                                setShowConsentsAgain
                                    ? style.consentsWidthOnWebSettings
                                    : style.consentsWidthOnWebModal
                            }
                        >
                            <View style={style.alignTitleAndTextWeb}>
                                <Text style={style.titleWeb}>
                                    {t('CONSENTS.SETTINGS_TITLE_MOBILES')}
                                </Text>
                                <Text style={style.textWeb}>
                                    {t('CONSENTS.SETTINGS_TEXT_MOBILES')}
                                </Text>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                <View />
                                <Pressable
                                    onPress={handleSelectAll}
                                    style={
                                        allSelected
                                            ? style.buttonSelectedAllWeb
                                            : style.buttonSelectAllWeb
                                    }
                                >
                                    <View style={style.alignToRow}>
                                        <Text
                                            style={[
                                                style.buttonText,
                                                style.acceotAllButtonAdditionalStyle
                                            ]}
                                        >
                                            {t('CONSENTS.SETTINGS_CONSENTS_ALL_MOBILES')}
                                        </Text>
                                    </View>
                                    <View style={style.checkBox}>
                                        <Checkbox
                                            approval={allSelected}
                                            borderColor="white"
                                            borderRadius={6}
                                            size={24}
                                            iconColor="white"
                                            backgroundColor="none"
                                        />
                                    </View>
                                </Pressable>
                            </View>
                            <View style={style.container}>
                                <ScrollView style={style.scrolableContainer}>
                                    {consents.map((item, index) => (
                                        <React.Fragment key={item.name}>
                                            {Device.isTabletOrWeb && (
                                                <View style={style.dividerStyle} />
                                            )}
                                            <NativeConsentItem
                                                approval={item.approval}
                                                consentTitle={t(item.consentText)}
                                                consentDescription={t(item.consentDescription)}
                                                link={item.consentDescriptionUrl}
                                                onCheckboxClick={async () => handleSelect(index)}
                                            />
                                        </React.Fragment>
                                    ))}
                                    <View style={style.dividerStyle} />
                                </ScrollView>
                                <View style={style.alignToRight}>
                                    <View style={style.alignToRow}>
                                        <Button
                                            title={t('CONSENTS.SETTINGS_SAVE_BTN_MOBILES')}
                                            onPress={handleAcceptSelected}
                                            importedStyle={style.acceptSelected}
                                        />
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </ScrollView>
            )}
            {Device.isPhone && (
                <View style={style.safeAreaContainer}>
                    <ScrollView style={style.scrolableContainer} ref={scrollViewRef}>
                        <Text style={style.title}>{t('CONSENTS.SETTINGS_TITLE_MOBILES')}</Text>
                        <Text style={style.text}>{t('CONSENTS.SETTINGS_TEXT_MOBILES')}</Text>
                        <Pressable
                            onPress={handleSelectAll}
                            style={
                                allSelected
                                    ? style.buttonSelectedAllMobile
                                    : style.buttonSelectAllMobile
                            }
                        >
                            <Text style={style.buttonText}>
                                {t('CONSENTS.SETTINGS_CONSENTS_ALL_MOBILES')}
                            </Text>
                            <View style={style.checkBox}>
                                <Checkbox
                                    approval={allSelected}
                                    borderColor="#FFFFFF"
                                    borderRadius={6}
                                    iconColor="white"
                                    size={24}
                                />
                            </View>
                        </Pressable>
                        <View style={style.spacing20} />
                        <View style={style.container}>
                            {consents.map((item, index) => (
                                <React.Fragment key={item.name}>
                                    {Device.isTabletOrWeb && <View style={style.dividerStyle} />}
                                    <NativeConsentItem
                                        approval={item.approval}
                                        consentTitle={t(item.consentText)}
                                        consentDescription={t(item.consentDescription)}
                                        link={item.consentDescriptionUrl}
                                        onCheckboxClick={async () => handleSelect(index)}
                                    />
                                    {index !== consents.length - 1 && (
                                        <View style={style.dividerStyle} />
                                    )}
                                </React.Fragment>
                            ))}

                            <View style={style.bottomButtonPadding}>
                                <Button
                                    title={t('CONSENTS.SETTINGS_SAVE_BTN_MOBILES')}
                                    onPress={handleAcceptSelected}
                                />
                            </View>

                            {/* <LinearGradient
                            colors={['rgba(0, 0, 0, 1)', 'rgba(0, 0, 0, 0)']}
                            start={{ x: 0, y: 1 }}
                            end={{ x: 0, y: 0 }}
                            style={style.gradientOverlay}
                        /> */}
                        </View>
                    </ScrollView>
                </View>
            )}
        </View>
    );
};

export default ConsentsDetailed;
